var _style, _line, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 251.2 756",
    style: {
      enableBackground: "new 0 0 251.2 756"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#935007;stroke-width:2;stroke-miterlimit:10;}\n\t.st1{fill:#935007;}\n\t.st2{fill:#b57335;}\n\t.st3{fill:#4c1e22;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#935007;}\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 99.1,
    y1: 462.6,
    x2: 99.1,
    y2: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Spinne"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.1,579.1c0,0,2.8,0.9,4.7,0c1.9-0.9,19.7-16.9,21.9-19c2.2-2.2,20.6-28.1,21.2-30 c0.6-1.9-2.5-68.5-14-91.8c0,0,21.5,33.9,23.4,92.6c0,0-17.8,35.9-53.7,59l-10.9-3.8L102.1,579.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.6,582.1c0,0-23.4-30.9-26.2-37.8c-2.8-6.9,10.9-72.4,47.5-103.4c0,0-31.2,28.4-32.8,99l23.7,31.5 L67.6,582.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.1,579.7c0,0-17.8-32.2-17.8-34.4c0-2.2,0.3-30.9,1.9-33.7c1.6-2.8,16.6-27.8,18.7-29.7S91.1,461,94.5,460 s5.6-0.9,7.5,0s17.5,20.6,18.7,24.3c1.2,3.7,11.2,41.5,11.2,45.3s-5.6,25.6-7.2,29.4s-5.9,10.3-7.8,11.5 c-1.9,1.2-11.2,10.3-11.2,10.3s5.3,5.6,5.9,8.1s0.9,15.9-0.3,19c-1.2,3.1-10.3,17.8-13.1,18.7s-19.6,4-23.4,4.7s-15-17.5-15.3-20.6 c-0.3-3.1,2.2-25.9,3.4-28.1C63.7,581.5,64.8,580.4,66.1,579.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.5,583.9c0,0,46.2-26.5,56.5-29.7c10.3-3.2,31.5-8.7,88.4,17.8c0,0-41.8-18.7-73.7-12.8 c-31.9,5.9-67.4,35.6-67.4,35.6L104.5,583.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.9,588.6c0,0,40.6-14,48.1-12.8c0,0,2.8,2.2,2.8,3.7c0,0,11.2,5.9-0.3,114c0,0,2.2-94.9-8.4-108.7 c0,0-22.8,5.9-36.5,13.7C94.9,606.3,102.9,588.6,102.9,588.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117,589.9c0,0,10.6,1.2,10.6,3.4c0,2.2-12.8,57.1-14,101.5c-1.2,44.4,1.9,59.3,1.9,59.3s-13.1-59.3-7.5-94.9 c5.6-35.6,8.7-59,8.7-59l-8.1-1.6L117,589.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.4,739.3c0,0-32.5-53.7-31.2-112.1c0,0,20.9-28.4,26.5-30l-2.2-11.9c0,0-31.2,26.6-32.8,37.2 C29.1,633.1,26.4,670.9,70.4,739.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.4,699c0,0,0.9-40.6,7.2-64.6s10-45.6,10-45.6l40.6-10l-1.6,6.2l-33.4,10c0,0-9.7,41.5-11.2,47.5 S14.2,669,11.4,699z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.8,527.9c0,0,51.5,11.6,70,54.5l-3.1,5.8C68.7,588.2,53.2,552.3,1.8,527.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.9,611.4c-0.3-3.1,3.9-23.2,5.1-25.4c0.7-1.3,1.8-2.4,3.1-3.1c0,0-16.3-32.1-16.3-34.3s-0.2-31.2,1.3-34 c1.5-2.8,15.5-26.1,17.7-28s17.8-24.6,22.1-27.1c-1.3,0.1-2.5,0.4-3.7,0.8c-3.4,0.9-23.4,20-25.6,21.9s-17,26.7-18.6,29.5 s-1.9,31.5-1.9,33.7s17.8,34.4,17.8,34.4c-1.3,0.7-2.4,1.8-3.1,3.1c-1.2,2.2-3.8,25-3.4,28.1c0.3,2.7,8,15.7,12.7,19.1 C68.4,623.3,65.1,613.4,64.9,611.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "69.2,575.7 64.4,568.1 55.4,548.5 56.7,515.4 72.2,490.7 94.1,462.6 69.9,514.4 70.9,544.7  67.9,558.2  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "eyeLeft"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 68.8,
    cy: 613.5,
    r: 9.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 68.3,
    cy: 617.6,
    r: 5.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M67.6,613.3c1-0.4,2.9,0,4.2,1.5c1,1.1,1.4,2.5,1,3.5c0.7-1.1,0.1-2.9-1.3-4.2c-1.3-1.1-2.7-1.3-3.8-0.9 c-0.7,0.3-0.6,0.3-0.9,0.4C67,613.5,67,613.5,67.6,613.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "eyeRight"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 90.1,
    cy: 618.7,
    r: 9.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 88.9,
    cy: 622,
    r: 5.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M88.2,617.7c1-0.4,2.9,0,4.2,1.5c1,1.1,1.4,2.5,1,3.5c0.7-1.1,0.1-2.9-1.3-4.2c-1.3-1.1-2.7-1.3-3.8-0.9 c-0.7,0.3-0.6,0.3-0.9,0.4C87.6,617.9,87.6,617.9,88.2,617.7z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpider);
export default __webpack_public_path__ + "static/media/spider.ab0987c0.svg";
export { ForwardRef as ReactComponent };